{
	"description": "Entitlement Templates for Jira Service Management Standard",
	"features": [
		{
			"featureId": "provided-allowances",
			"domain": "BILLING",
			"value": {
				"allowances": [
					{
						"reference": "allowance_indexed-document",
						"type": "ALLOWANCE",
						"config": {
							"usageKey": "indexed-document",
							"cycles": [
								{
									"schedule": "BILLING",
									"cycle": "MONTHLY",
									"amount": 100,
									"relativeTo": {
										"referenceType": "CHARGE_ELEMENT",
										"referenceValue": "agent"
									}
								},
								{
									"schedule": "BILLING",
									"cycle": "ANNUAL",
									"amount": 100,
									"relativeTo": {
										"referenceType": "CHARGE_ELEMENT",
										"referenceValue": "agent"
									}
								}
							],
							"isConsumer": false,
							"recipientEntity": "POOL"
						}
					},
					{
						"reference": "allowance_ai-credit",
						"type": "ALLOWANCE",
						"config": {
							"usageKey": "ai-credit",
							"cycles": [
								{
									"schedule": "BILLING",
									"cycle": "MONTHLY",
									"amount": 25,
									"relativeTo": {
										"referenceType": "CHARGE_ELEMENT",
										"referenceValue": "agent"
									}
								},
								{
									"schedule": "BILLING",
									"cycle": "ANNUAL",
									"amount": 25,
									"relativeTo": {
										"referenceType": "CHARGE_ELEMENT",
										"referenceValue": "agent"
									}
								}
							],
							"isConsumer": false,
							"recipientEntity": "POOL"
						}
					},
					{
						"reference": "allowance_assets-objects",
						"type": "ALLOWANCE",
						"config": {
							"usageKey": "assets-objects",
							"cycles": [
								{
									"schedule": "BILLING",
									"cycle": "MONTHLY",
									"amount": 5000
								},
								{
									"schedule": "BILLING",
									"cycle": "ANNUAL",
									"amount": 5000
								}
							],
							"isConsumer": false,
							"recipientEntity": "POOL"
						}
					},
					{
						"reference": "allowance_automation-credits",
						"type": "ALLOWANCE",
						"config": {
							"usageKey": "automation-credits",
							"cycles": [
								{
									"schedule": "BILLING",
									"cycle": "MONTHLY",
									"amount": 2500,
									"relativeTo": {
										"referenceType": "CHARGE_ELEMENT",
										"referenceValue": "agent"
									}
								},
								{
									"schedule": "BILLING",
									"cycle": "ANNUAL",
									"amount": 2500,
									"relativeTo": {
										"referenceType": "CHARGE_ELEMENT",
										"referenceValue": "agent"
									}
								}
							],
							"isConsumer": false,
							"recipientEntity": "POOL"
						}
					}
				]
			}
		}
	]
}
